module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--8-ca770d67ab579051c8aa3cf0749a6b64.jpg";